import ListaCompressores from "./ListaCompressores";
import AlertDialogOnClose from "../../../../components/admin/AlertDiologOnClose";
export default function CompressorForm() {

    return (
        <AlertDialogOnClose nome={"Compressor"} placeholder={"Insira o nome do compressor"}>
            <ListaCompressores/>
        </AlertDialogOnClose>
    )
} 